import { Component, EventEmitter, Input, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { ReplaySubject, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import {
  ClienteComboOutput,
  PedidoConsultaOutput,
} from "src/app/@shared/models/consulta-detalhe";
import { ConsultaDetalhesPorNRTInput } from "src/app/@shared/models/consulta-detalhes/consulta-detalhes.model";
import { StorageService } from "src/app/services/storage/storage.service";
import { DetalheFormularioComponent } from "../detalhe-formulario/detalhe-formulario.component";

@Component({
  selector: "app-detalhe-formulario-nrt",
  templateUrl: "./detalhe-formulario-nrt.component.html",
  styleUrls: ["./detalhe-formulario-nrt.component.scss"],
})
export class DetalheFormularioNrtComponent implements OnInit {
  usuario = StorageService.getPerfilUsuario();
  urlParams: any;
  @Input('clientes') clientes: number[];

  public clientesFiltrados: ReplaySubject<ClienteComboOutput[]> =
    new ReplaySubject<ClienteComboOutput[]>(1);
  private onDestroy = new Subject<void>();
  public clienteMultiFilter: FormControl = new FormControl();


  formConsultaNrt = new FormGroup({
    codigoNrt: new FormControl("", Validators.required),
    cliente: new FormControl(),
  });

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.queryParamMap.subscribe((params) => {
      this.urlParams = { ...params };
    });
    if (this.urlParams.params.pedidoId) {
      this.formConsultaNrt.get("codigoNrt").setValue(this.urlParams.params.pedidoId);
      setTimeout(() => {
        this.search();
      }, 100);
    }
    this.clienteMultiFilter.valueChanges
      .pipe(takeUntil(this.onDestroy))
      .subscribe(() => {
        this.filtroGeral(
          this.clientes,
          this.clienteMultiFilter,
          this.clientesFiltrados,
          "nome"
        );
      });
  }

  private filtroGeral(
    filtro: any,
    multifilter: any,
    filtered: any,
    field: string
  ) {
    if (!filtro) {
      return;
    }
    let search = multifilter.value;
    if (!search) {
      filtered.next(filtro.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    filtered.next(
      filtro.filter(
        (response) => response[field].toLowerCase().indexOf(search) > -1
      )
    );
  }

  public onInput: EventEmitter<ConsultaDetalhesPorNRTInput> =
    new EventEmitter();
  search() {
    this.onInput.emit({
      pedidoid: this.formConsultaNrt.get("codigoNrt").value,
    });
  }
}
